module.exports = "<nav>\r\n  <a [routerLink]=\"['/']\" [routerLinkActive]=\"['router-link-active']\" [routerLinkActiveOptions]=\"{exact:true}\">HOME</a>\r\n  <a [routerLink]=\"['/about']\" [routerLinkActive]=\"['router-link-active']\" [routerLinkActiveOptions]=\"{exact:true}\">ABOUT</a>\r\n</nav>\r\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/navbar/navbar.component.html
// module id = ../../../../../src/app/shared/navbar/navbar.component.html
// module chunks = main